import { useEffect } from "react";
import { Link } from "react-router-dom";

function DonorChoosenSample({ sampleTypes, userData, userType }) {
    return (
        <>
            <div className="col-md-6 mb-3 mb-md-0">
                <div className="alert alert-dark h-100" role="alert">
                    {/* <h3 className="mb-4 ">Chosen Sample Type</h3> */}
                    <h3 className="mb-4 ">  {userType !=="donor" ? "Samples Willing To Donate" : "Samples You Are Willing To Donate"}</h3>
                    <div className="el-dononr-sample-type">
                        <div>
                              {/* {userType !=="donor" && (
                            sampleTypes?.length > 0 ? (
                                sampleTypes.some(sample => userData.sample_id?.includes(sample.id)) ? (
                                    sampleTypes.map((sample) =>
                                        userData.sample_id?.includes(sample.id) ? (
                                            <div
                                                className={`btn bg-${sample.divClass} text-white el-sample-btn`}
                                                key={sample.id}
                                                >
                                                <i className={sample.className}></i> {sample.label}
                                                </div>
                                            ) : null
                                        )
                                    ) : (
                                        <p>No samples available</p>
                                    )
                                ) : (
                                    <p>No samples available</p>
                                )
                            )}   */}

                            {/* //for Donor controle's Donation History */}
                            {/* {userType === "donor" && ( */}
                            {
                                sampleTypes?.length > 0 ? (
                                    userData?.samples?.some((userSample) =>
                                        sampleTypes.some((sampleType) => sampleType.id === String(userSample.sample_id))
                                    ) ? (
                                        sampleTypes.map((sampleType) => {
                                            // Check if this sampleType exists in userData.samples
                                            const isUserSample = userData?.samples?.some(
                                                (userSample) => String(userSample.sample_id) === sampleType.id
                                            );

                                            return isUserSample ? (
                                                <div
                                                    className={`btn bg-${sampleType.divClass} text-white el-sample-btn`}
                                                    key={sampleType.id}
                                                >
                                                    <i className={sampleType.className}></i> {sampleType.label}
                                                </div>
                                            ) : null;
                                        })
                                    ) : (
                                        <p>No samples available</p>
                                    )
                                ) : (
                                    <p>No samples available</p>
                                )
                            }
                            {/* )}   */}
                        </div>
                        <div className="mt-2 el-sample-btn"> 
                            {userType==="donor" && (<Link to={'/profile-management/profile-settings#donate-sample'}>Change Sample Types</Link>)}
                        </div>

                        {/*  <div className="btn bg-danger text-white border-0"><i className="el-icon-buccal-swab"></i> Blood</div>
                                        <div className="btn bg-bodyla-fluid  text-white border-0"><i className="el-icon-bodily-fluid"></i> Bodily Fluid</div>
                                        <div className="btn bg-bukkal-swab  text-white border-0"><i className="el-icon-buccal-swab"></i> Buccal Swab</div>
                                        <div className="btn bg-hair-follicle  text-white border-0"><i className="el-icon-hair-follicle"></i> Hair Follicle</div>
                                        <div className="btn bg-text-skin-tap  text-white border-0"><i className="el-icon-skin-tape"></i> Skin Tape</div>
                                        <div className="btn bg-stool  text-white border-0 "><i className="el-icon-stool"></i> Stool</div> */}
                    </div>
                </div>
            </div>
        </>
    );
}


export default DonorChoosenSample